import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { configOptions } from '../config';

export const appInsights = new ApplicationInsights({ config: {
  connectionString: 'InstrumentationKey=' + configOptions.instrumentationKey + ';EndpointSuffix=applicationinsights.us;IngestionEndpoint=https://usgovvirginia-0.in.applicationinsights.azure.us/',
  autoTrackPageVisitTime: true
} });